import classNames from 'classnames';
import React from 'react';
import * as styles from './SeriesIcon.module.scss';
import SVGIcon from '../components/SVGIcon';
import seriesIcon from '../icons/prefilled/16x16/series.svg';

interface SeriesIconProps {
  archived?: boolean;
  bordered?: boolean;
}

const SeriesIcon = ({ archived, bordered }: SeriesIconProps) => (
  <div
    className={classNames(styles.icon, {
      [styles.archived]: archived,
      [styles.bordered]: bordered,
    })}
  >
    <SVGIcon>{seriesIcon}</SVGIcon>
  </div>
);

export default SeriesIcon;
